import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { Box, FormLabel, Grid, IconButton, Tooltip } from '@material-ui/core'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'

import { DefaultSelect } from './DefaultSelect'

import { useSettingsPageStyles } from '../hooks/settingsPageStylesHook'

import { MoySkladApiEntityOption } from '../server/mpsklad_core/Models/MoySkladApiEntityOption'

export type PriceTypeSelectProps = {
  label: string
  placeholder: string
  tooltip: string | undefined
  selectedId: string | undefined
  onChange: (id: string | undefined) => void
  options: MoySkladApiEntityOption[]
  isLoading: boolean
}

export const PriceTypeSelect =
  observer(
    ({
       label,
       placeholder,
       tooltip,
       selectedId,
       onChange,
       options,
       isLoading = false
     }: PriceTypeSelectProps) => {
      const classes = useSettingsPageStyles()

      const selectedOption = options.find(o => o.id === selectedId)

      return (
        <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
          <Box marginBottom={1}>
            <FormLabel component="legend" className={classes.label}>
              <span className={classes.dash}>—</span>
              {label}
              {
                tooltip &&
                <Tooltip title={tooltip} arrow>
                  <IconButton size="small" className={classes.helperIcon}>
                    <HelpOutlineIcon fontSize="small"/>
                  </IconButton>
                </Tooltip>
              }
            </FormLabel>
          </Box>

          <DefaultSelect<MoySkladApiEntityOption>
            fullWidth
            withUnselectedValue
            value={selectedOption}
            onChange={option => onChange(option?.id)}
            options={options.map(o => ({value: o, label: o.name}))}
            placeholder={placeholder}
            isLoading={isLoading}
          />
        </Grid>
      )
    })